import { DisplayWebContentNode } from './components/Nodes/DisplayWebContentNode';
import { EndOfFlowNode } from './components/Nodes/EndOfFlowNode';
import { MessageDropzoneNode } from './components/Nodes/MessageDropzoneNode';
import { SendEmailMessageNode } from './components/Nodes/SendEmailMessageNode';
import { TriggerNode } from './components/Nodes/TriggerNode';
import { NodeTypeKeys } from '../../domain/Canvas/utils/NodeTypeKeys';
import { BranchControlNode } from './components/Nodes/ConfigBranchNode';
import { BranchNameNode } from './components/Nodes/BranchNameNode';
import { DropNode } from './components/Nodes/DropNode';

export const NodeTypes: { [key in keyof typeof NodeTypeKeys]: any } = {
  triggerNodeType: TriggerNode,
  dropzoneNodeType: MessageDropzoneNode,
  dropNodeType: DropNode,
  endOfFlowNodeType: EndOfFlowNode,
  displayWebContentNodeType: DisplayWebContentNode,
  sendEmailNodeType: SendEmailMessageNode,
  branchControlNodeType: BranchControlNode,
  branchNameNodeType: BranchNameNode,
};
